import { useAuth } from "@clerk/react"
import { RouterProvider } from "@tanstack/react-router"

import { queryClient } from "@/lib/query-client"
import { router } from "@/router"

export function AppRouter() {
  const auth = useAuth()
  return <RouterProvider router={router} context={{ auth, queryClient }} />
}
